
const user = {
    state: {
        isROOT: false,
        myRoles: [],
        user: null,
        resKeys: new Set(), // 角色 所拥有的 资源标识
        resUris: new Set() // 对应uri
    },
    getters: {
        hasAuth: (state) => (resKey) => {
            return state.isROOT || state.resKeys.has(resKey);
        }
    },
    mutations: {
        setROOT (state, status) {
            state.isROOT = status;
        },
        setMyRoles(state, roles) {
            state.myRoles = roles;
        },
        setUserCompanyLogo(state, url){
            state.user.current_logo = url;
        },
        setUser(state, user) {
            user.birthday = new Date(user.birthday);
            user.token_end_time = new Date(user.token_end_time);
            user.j_depart_ids = JSON.parse(user.j_depart_ids);
            user.departs.forEach(depart => {
                depart.j_auth_list = JSON.parse(depart.j_auth_list);
                depart.j_community_ids = JSON.parse(depart.j_community_ids);
                depart.j_region = JSON.parse(depart.j_region);
                if (depart.company_id === user.current_company) user.role = depart.role_type;
            })
            user.companies.forEach(comp => {
                comp.j_community_ids = JSON.parse(comp.j_community_ids);
                comp.j_company_chain = JSON.parse(comp.j_company_chain);
                comp.j_region = JSON.parse(comp.j_region);
                comp.role_auth = (JSON.parse(comp.role_auth) || []).concat(JSON.parse(comp.j_extra_auth) || []);
                if (comp.id === user.current_company) user.company = comp;
            })
            state.isROOT = user.company && user.company.role_type === "ROOT";
            state.user = user;
            let res_keys = new Set();
            let res_uris = new Set();
            user.departs.forEach(d => {
                //  用户当前操作公司或者部门
                if (d.company_id !== user.current_company) return;
                // if (d.id !== user.current_company) return;
                if(d.id === user.current_company){
                    d.j_auth_list.forEach(key => {res_keys.add(key)})
                    d.j_auth_uris.forEach(uri => {res_uris.add(uri)})
                }
            })
            state.resKeys = res_keys;
            state.resUris = res_uris;
        },
        setUserCompany (state, id) {
            state.user.current_company = id;
        },
        addUserCommunity(state,com){
            state.user.communitys.push(com)
        },
        updateHeadUrl(state,head_url){
            state.user.head_url = head_url;
        }
    }
};

export default user;
